module.exports = __webpack_public_path__ + "static/media/icon-grip-style.d8c4436f.svg";